
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.333.833A7.5 7.5 0 0114.3 12.88l4.597 4.214a.833.833 0 01-1.126 1.229l-4.623-4.238A7.5 7.5 0 118.333.833zm0 1.667a5.833 5.833 0 100 11.667 5.833 5.833 0 000-11.667z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    